import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SectionGrid from '@/components/feature/SectionGrid';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import { videoList } from '@/mocks/videos';
import { getLatest, getPopular } from '@/utils/video';

const highlights = [
  { icon: 'ri-film-line', title: '海量片库', desc: '电影、电视剧、综艺多类型内容持续更新，总有一部合你心意。' },
  { icon: 'ri-hd-line', title: '高清流畅', desc: '优化演示播放体验，支持清晰度与剧集切换，观看更顺畅。' },
  { icon: 'ri-gift-line', title: '完全免费', desc: '无需注册即可浏览全站内容，收藏与观看历史保存于本地浏览器。' },
  { icon: 'ri-device-line', title: '多端适配', desc: 'PC 与移动端自适应布局，随时随地畅享影视内容。' },
];

export default function Home() {
  useEffect(() => {
    document.title = '在线免费观看-海量影视资源在线观看平台';
  }, []);

  const latest = getLatest(videoList, 8);
  const popular = getPopular(videoList, 8);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <HeroCarousel />

        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
          <CategoryEntries />

          <SectionGrid
            title="最新上线"
            subtitle="刚刚入库的影视内容，第一时间追更不错过"
            videos={latest}
            moreLink="/category/movie"
          />

          <SectionGrid
            title="热门推荐"
            subtitle="播放量与好评双高的口碑之作，鼠标悬浮可预览简介"
            videos={popular}
            moreLink="/category/tv"
          />

          <section className="w-full py-10">
            <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10">
              <div className="max-w-3xl">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  <a href="#site-intro" className="cursor-pointer">网站简介</a>
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  “在线免费观看”是一个专注于免费高清视频内容的在线影视门户，汇集电影、电视剧、综艺节目等多种类型资源，
                  支持分类浏览、多维筛选与关键词搜索，帮助每一位影视爱好者快速找到心仪内容，享受稳定流畅的观影体验。
                  站内所有内容均为演示数据，用于展示产品功能与页面设计。
                </p>
              </div>

              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {highlights.map((item) => (
                  <div key={item.title} className="p-5 rounded-lg bg-background-50 border border-background-200">
                    <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-4">
                      <i className={`${item.icon} text-2xl`}></i>
                    </span>
                    <h3 className="font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}